import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ReunionProvider } from './contexts/ReunionContext';
import { queryClient } from './lib/queryClient';
import { getBaseUrl } from './utils/routing';
import './styles/index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ReunionProvider>
        <BrowserRouter basename={getBaseUrl()}>
          <App />
        </BrowserRouter>
      </ReunionProvider>
    </QueryClientProvider>
  </React.StrictMode>
); 